// Which options a pricelist actually OFFERS as packages on the choose-your-package
// screen, and in what order. Extracted from the component so the rules are testable —
// they decide what a customer can buy, and getting them wrong either hides a package or
// sells an add-on twice.

import { hasArtwork } from '../../utils/optionArtwork';

export { hasArtwork };

// The school's price. Options arrive with prices already scoped to the school
// (usePackageOptions), so the first row IS this school's price.
export const priceOf = (option) => option?.prices?.[0]?.price ?? null;

export default function offeredOptions(options, excludeOption = null) {
  // An option with a `code` is an ADD-ON, not a package — "Magnets" on an elementary
  // pricelist, "Select Yearbook Pose" on a senior one. They're sold elsewhere in the flow,
  // so a code'd option here would be a duplicate sale, not a choice.
  const packages = (options || []).filter((option) => !option.code);

  // The senior_buy_all_promo option ("Buy All Your Photos") is the discounted
  // POST-PURCHASE upsell — offered on its own screen only after the customer has
  // chosen a print package. It must never appear as a package on this grid.
  // NOTE: don't identify it by its buy-all banner (isBuyAll) — the full-price
  // "All Digital" package legitimately carries a banner too and belongs here.
  const notUpsell = packages.filter((option) => !option.seniorBuyAllPromo);

  // No price for this school => not buyable here. A card with no price is a dead end.
  const priced = notUpsell.filter((option) => priceOf(option) !== null);

  const kept = excludeOption ? priced.filter((option) => !excludeOption(option)) : priced;

  // Nothing to show — no name, no description, no artwork — would render an empty card.
  // These exist on real pricelists.
  const showable = kept.filter((option) => option.name || option.description || hasArtwork(option));

  // Featured first, then most expensive: the pricelist's own idea of what to lead with.
  return [...showable].sort((a, b) => {
    if (!!a.featured !== !!b.featured) return a.featured ? -1 : 1;
    return (priceOf(b) || 0) - (priceOf(a) || 0);
  });
}
